import { VITE_BASE_URL } from "./config";

export const BASE_URL = VITE_BASE_URL;
